import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'ngx-webstorage';
import { CreateService } from 'src/app/services/create.service';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss']
})
export class UploadDialogComponent {

  fileList: File[] = [];
  folder: any;
  folderName: any = '';
  selectedFiles: any = [];
  userEmailId = this.storage.retrieve("userEmailId");
  destFolderId: any;
  success: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialog, private storage: LocalStorageService, private createService: CreateService, private toastr: ToastrService) {
    // console.log(data);

  }

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      var selectedFile = event.target.files[i];
      this.fileList.push(selectedFile);
    }
  }

  selectFolder(event: any): void {
    console.log(event.target.files);
    this.folder = event.target.files;
    var name = event.target.files[0].webkitRelativePath.split('/');
    this.folderName = name[0];
  }

  delete(i: any) {
    this.fileList.splice(i, 1);
  }

  uploadFile() {
    if (this.data.isUserAccessTemplate) { 
      if(this.fileList.length != 0) {
        this.createService.uploadUserAccessTemplateFromServer(this.fileList).subscribe({
          next: (data: any) => {
            console.log(data, typeof(data))
            if (data) {
              this.success = true;
              this.toastr.success('The file(s) has been uploaded successfully.', 'Success!');
            }
            else {
              this.success = false;
              this.toastr.error('The file(s) could not be uploaded. Kindly try again later.', 'Error!');
            }
            this.dialogRef.closeAll();
          },
          error: (e: any) => {
            this.success = false;
            if(e.status == 403){
              this.toastr.error(e.error + " " + "(Insufficient Permission)");
            }else{
              this.toastr.error('The file(s) could not be uploaded. Kindly try again later.', 'Error!');
            }
          }
        })
      }
    }
    else {

      if (this.data.type == 'file') {
        if (this.fileList.length != 0) {
          this.destFolderId = this.data.folder.id;
          this.createService.uploadFile(this.destFolderId, this.userEmailId, this.fileList).subscribe({
            next: (data: any) => {
              if (data == "Success") {
                this.success = true;
                this.toastr.success('The file(s) has been uploaded successfully.', 'Success!');
              }
              else {
                this.success = false;
                this.toastr.error('The file(s) could not be uploaded. Kindly try again later.', 'Error!');
              }
            },
            error: (e: any) => {
              this.success = false;
              if(e.status == 403){
                this.toastr.error(e.error + " " + "(Insufficient Permission)");
              }else{
              this.toastr.error('The file(s) could not be uploaded. Kindly try again later.', 'Error!');
              }
            }
          })
        }
        else {
          this.toastr.warning('Kindly upload atleast one file to continue', 'Warning!');
        }
      }
      else {
        this.destFolderId = this.data.folder.id;
        this.createService.uploadFolder(this.destFolderId, this.userEmailId, this.folderName, this.folder).subscribe({
          next: (data: any) => {
            if (data == "Created Folder") {
              this.success = true;
              this.toastr.success('The folder has been uploaded successfully.', 'Success!');
            }
            else {
              this.success = false;
              this.toastr.error('The folder could not be uploaded. Kindly try again later.', 'Error!');
            }
          },
          error: (e: any) => {
            this.success = false;
            if(e.status == 403){
              this.toastr.error(e.error + " " + "(Insufficient Permission)");
            }else{
            this.toastr.error('The folder could not be uploaded. Kindly try again later.', 'Error!');
          }
        }
        })
      }
    }
  }

}
